var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { panoramaViewer } from "./utils/panoramaViewer";
import { DURATIONS, ROTATIONS } from "./utils/standardPanoramaViewerData";
import { RenderLayer } from "../../api";
import { defaultRendererConfig } from "./index";
export function panoramaView4(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Panorama View 4" +
                "</h1>" +
                "<p>" +
                "The entire view will be replaced with a panoramic image, that should render normally." +
                "</p>" +
                "<p>" +
                "Also included is an object added to the 'AfterPanorama' pass that should render atop the panorama." +
                "</p>";
        yield panoramaViewer(defaultRendererConfig(container), DURATIONS, ROTATIONS, (renderer) => __awaiter(this, void 0, void 0, function* () {
            const pano = yield renderer.getObjectFactory().createPanorama({
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/models/pano/R0011230.JPG",
            });
            renderer.getWorld().addPanorama(pano);
            const box = renderer.getObjectFactory().createBox({
                position: {
                    ecef: [-5, 0, -5],
                },
                size: {
                    x: 2,
                    y: 2,
                    z: 2,
                },
                material: {
                    type: "physicalOpaque",
                    baseColor: {
                        r: 1,
                        g: 0,
                        b: 0,
                    },
                    metallic: 0,
                    roughness: 0,
                },
            });
            box.setRenderLayer(RenderLayer.AfterPanorama);
            renderer.getWorld().addObject(box);
        }));
    });
}
